import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Main} from "../../pages/main";
import {Agreement} from '../../pages/agreement'
import {PrivacyPolicy} from "../../pages/privacyPolicy";
import {Layout} from "../layout";
import {AccreditationPage} from "../../pages/accreditationPage";
import {ProductPage} from "../../pages/productPage";

export const AppRoutes = () => {
  return (
    <Routes>
        <Route element={<Layout />}>
            <Route path="/" element={<Main />} />
            <Route path="/agreement" element={<Agreement />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/accreditation-page" element={<AccreditationPage />} />
            <Route path="/product/:titleProduct" element={<ProductPage />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Route>
    </Routes>
  );
};
